import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  mutableMapOfk2y3zt1azl40 as mutableMapOf,
  mapOf1xd03cq9cnmy8 as mapOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { withTimeoutg7xid1ng7ofr as withTimeout } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import {
  WsFrameType_Text_getInstancep47mhyh18o1i as WsFrameType_Text_getInstance,
  WsProtocol2u70gp1eq7nu9 as WsProtocol,
} from './WsProtocol.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Companion_instance2ugsdh0psp7vj as Companion_instance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass;
function SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b() {
  if (SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass === VOID) {
    class $ {
      td($completion) {
        return null;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass = $;
  }
  return SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass;
}
function SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b_0() {
  var i = new (SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b())();
  var l = ($completion) => i.td($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$withTimeout, $completion) {
  var tmp = $this.y68_1.b69($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var map = tmp;
  var type = map.z4('type');
  if (equals(type, 'connection_ack'))
    return Unit_instance;
  else if (equals(type, 'connection_error'))
    throw ApolloNetworkException().d47('Connection error:\n' + toString_0(map));
  else {
    println("unknown message while waiting for connection_ack: '" + toString(type));
  }
  return Unit_instance;
}
function *_generator_connectionInit__x4b1za($this, $completion) {
  var message = mutableMapOf([to('type', 'connection_init')]);
  var tmp = $this.f69_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var payload = tmp;
  if (!(payload == null)) {
    message.c5('payload', payload);
  }
  $this.h69(message, $this.g69_1);
  var tmp_0 = withTimeout($this.e69_1, SubscriptionWsProtocol$connectionInit$slambda_0($this), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var FactoryClass;
function Factory() {
  if (FactoryClass === VOID) {
    class $ {
      constructor(connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b_0();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        this.i69_1 = connectionAcknowledgeTimeoutMs;
        this.j69_1 = connectionPayload;
        this.k69_1 = frameType;
      }
      m1() {
        return 'graphql-ws';
      }
      l69(webSocketConnection, listener, scope) {
        var tmp0_connectionPayload = this.j69_1;
        var tmp1_connectionAcknowledgeTimeoutMs = this.i69_1;
        var tmp2_frameType = this.k69_1;
        return new (SubscriptionWsProtocol())(webSocketConnection, listener, tmp1_connectionAcknowledgeTimeoutMs, tmp0_connectionPayload, tmp2_frameType);
      }
    }
    initMetadataForClass($, 'Factory', Factory);
    FactoryClass = $;
  }
  return FactoryClass;
}
var SubscriptionWsProtocol$_init_$slambda_7z3jffClass;
function SubscriptionWsProtocol$_init_$slambda_7z3jff() {
  if (SubscriptionWsProtocol$_init_$slambda_7z3jffClass === VOID) {
    class $ {
      td($completion) {
        return null;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SubscriptionWsProtocol$_init_$slambda_7z3jffClass = $;
  }
  return SubscriptionWsProtocol$_init_$slambda_7z3jffClass;
}
function SubscriptionWsProtocol$_init_$slambda_7z3jff_0() {
  var i = new (SubscriptionWsProtocol$_init_$slambda_7z3jff())();
  var l = ($completion) => i.td($completion);
  l.$arity = 0;
  return l;
}
var SubscriptionWsProtocol$connectionInit$slambdaClass;
function SubscriptionWsProtocol$connectionInit$slambda() {
  if (SubscriptionWsProtocol$connectionInit$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.y68_1 = this$0;
      }
      c1g($this$withTimeout, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withTimeout), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscriptionWsProtocol$connectionInit$slambdaClass = $;
  }
  return SubscriptionWsProtocol$connectionInit$slambdaClass;
}
function SubscriptionWsProtocol$connectionInit$slambda_0(this$0) {
  var i = new (SubscriptionWsProtocol$connectionInit$slambda())(this$0);
  var l = ($this$withTimeout, $completion) => i.c1g($this$withTimeout, $completion);
  l.$arity = 1;
  return l;
}
var SubscriptionWsProtocolClass;
function SubscriptionWsProtocol() {
  if (SubscriptionWsProtocolClass === VOID) {
    class $ extends WsProtocol() {
      constructor(webSocketConnection, listener, connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$_init_$slambda_7z3jff_0();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        super(webSocketConnection, listener);
        this.e69_1 = connectionAcknowledgeTimeoutMs;
        this.f69_1 = connectionPayload;
        this.g69_1 = frameType;
      }
      m69($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_connectionInit__x4b1za.bind(VOID, this), $completion);
      }
      n69(messageMap) {
        var tmp0_subject = messageMap.z4('type');
        if (equals(tmp0_subject, 'data')) {
          var tmp = messageMap.z4('id');
          var tmp_0 = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
          var tmp_1 = messageMap.z4('payload');
          this.a69_1.r69(tmp_0, (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE());
        } else if (equals(tmp0_subject, 'error')) {
          var id = messageMap.z4('id');
          if (!(id == null) ? typeof id === 'string' : false) {
            var tmp_2 = messageMap.z4('payload');
            this.a69_1.q69(id, (tmp_2 == null ? true : isInterface(tmp_2, KtMap())) ? tmp_2 : THROW_CCE());
          } else {
            var tmp_3 = messageMap.z4('payload');
            this.a69_1.p69((tmp_3 == null ? true : isInterface(tmp_3, KtMap())) ? tmp_3 : THROW_CCE());
          }
        } else if (equals(tmp0_subject, 'complete')) {
          var tmp_4 = messageMap.z4('id');
          this.a69_1.o69((!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
        }
      }
      s69(request) {
        this.h69(mapOf([to('type', 'start'), to('id', request.t42_1.toString()), to('payload', Companion_instance.a48(request))]), this.g69_1);
      }
      t69(request) {
        this.h69(mapOf([to('type', 'stop'), to('id', request.t42_1.toString())]), this.g69_1);
      }
    }
    initMetadataForClass($, 'SubscriptionWsProtocol', VOID, VOID, VOID, [0]);
    SubscriptionWsProtocolClass = $;
  }
  return SubscriptionWsProtocolClass;
}
//region block: exports
export {
  Factory as Factory2jyzsj2j7cj0z,
};
//endregion

//# sourceMappingURL=SubscriptionWsProtocol.mjs.map
